import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import messages from '../../../assets/messages'
import {Controls, ControlButton} from './TreeControls.styled'
import {useExpansion} from './ExpansionContext'

/**
 * The "Expand all / Collapse all" control sitting above the tree (PT-5721). It flips the whole
 * hierarchy in one action through the shared expansion state, so a Master with a deep network can
 * open everything at once or reset to the collapsed default without clicking node by node.
 *
 * @param t - Translation function injected by `withNamespaces`, used for the group aria-label.
 */
const _TreeControls = ({t}: WithNamespaces) => {
  const {expandAll, collapseAll} = useExpansion()

  return (
    <Controls
      role="group"
      aria-label={t(messages.pammTreeControlsLabel.i18nKey, messages.pammTreeControlsLabel.defaults)}
      data-testid="pamm-tree-controls"
    >
      <ControlButton type="button" onClick={expandAll} data-testid="pamm-expand-all">
        <Trans {...messages.pammExpandAll} />
      </ControlButton>
      <ControlButton type="button" onClick={collapseAll} data-testid="pamm-collapse-all">
        <Trans {...messages.pammCollapseAll} />
      </ControlButton>
    </Controls>
  )
}

export const TreeControls = withNamespaces()(_TreeControls)
